import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames';
import LoadingPlaceholder from '../../../components/LoadingPlaceholder';
import ContactGroup from '../ContactGroup';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import './styles.css';
class StickyContact extends PureComponent {

  render() {
    const isManufacturer = get(this.props, 'isManufacturer', false);
    const { isLoading } = this.props;
    return (
      <div className={classnames('sticky-contact', { 'sticky-contact-manufacturer': isManufacturer } )}>
        {isLoading
          ? this.renderLoading()
          : this.renderContact()}
      </div>
    );
  }

  renderLoading() {
    return <LoadingPlaceholder type="text" />;
  }

  renderContact() {
    return <ContactGroup {...this.props} />;
  }
}

StickyContact.defaultProps = {
  isLoading: false,
  isManufacturer: false,
};

StickyContact.propTypes = {
  isLoading: PropTypes.bool,
  listing: listingPropTypes,
  isManufacturer: PropTypes.bool,
};

export default StickyContact;
